export default function destroys (self) {
  // Grab the original destroy function from the widget
  const oldDestroy = self._destroy

  // Create an array of cleanup functions (destroyables)
  self._destroyables = []

  // Replace the old function with our copy (this is a widget hook)
  self._destroy = (...args) => {
    // Loop through destroyables and call each one
    self._destroyables.forEach(callFn(...args))

    // Call the old fn for good measure
    if (oldDestroy) oldDestroy.apply(self, args)
  }

  // Call self.destroys(fn) to add fn to the destroyables
  self.destroys = (...args) => {
    // Keep it fresh and immutable
    self._destroyables = [].concat(self._destroyables, args)
  }
}

// Helper to call functions in an array
function callFn (...args) {
  return fn => {
    if (typeof fn === 'function') {
      return fn(...args)
    }
  }
}
